import React from 'react';
import { motion } from "framer-motion";
import { animationProps } from '../props/props';

interface WelcomeProps {
  className?: string;
}

const Welcome: React.FC<WelcomeProps> = () => {
  return (
    <motion.div className="animated-wrapper" {...animationProps}>
      <div className='inner'>
        <div className="row">
          <div className="col">
            <p><strong>Hello!</strong> My name is Nick Deimler, and I make websites. Hopefully that's what you're here for. Take a look at my portfolio to see a few of the projects I've completed, and if you want a more technical breakdown of what exactly I do, see my r&eacute;sum&eacute;. If you like what you see and are interested in hiring, send me an <a href="mailto:ndeimler@gmail.com">email</a>.</p>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default Welcome; 